import {
  DatePickerV2,
  TextInputV2,
  labraUIDateFormat,
} from '@labrav/react-components'
import { Grid, Typography } from '@mui/material'
import { FormikProps, useFormikContext } from 'formik'
import { isEmpty } from 'lodash'

import { useStyles } from './RecipientCompanyDetail.styles'
import type { AgreementBasedOffer } from '../../../../modules/subscription/reducer'
import { agreementOfferExpirationDateField } from '../../../../mocks/agreementBasedOfferFields'
import { OfferRecipientV2 } from '../../../../common/components/OfferRecipientV2/OfferRecipientV2'

export const RecipientCompanyDetail = () => {
  const formikProps = useFormikContext() as FormikProps<AgreementBasedOffer>
  const { values, errors, touched, handleChange, handleBlur } = formikProps
  const { classes } = useStyles()

  const offerExpiryDateField = {
    ...agreementOfferExpirationDateField,
    defaultValue: !isEmpty(values?.offerExpirationDate)
      ? values?.offerExpirationDate
      : null,
  }

  return (
    <div className={classes.root}>
      <div>
        <Typography className={classes.subTitle}>Company details</Typography>
        <Grid container spacing={4}>
          <Grid size={6}>
            <div key={'comapny-name'}>
              <TextInputV2
                keyName={'companyName'}
                title="Company name"
                type="text"
                placeHolder="Company name"
                value={values.companyName as string}
                onChange={handleChange}
                isReadOnly={false}
                isRequired={false}
                isError={!!(errors.companyName && touched.companyName)}
                errorText={(!!touched.companyName && errors.companyName) || ''}
                showSpinner={false}
                onBlur={handleBlur}
              />
            </div>
          </Grid>
          <Grid size={6}>
            <div key={'aws-account-id'}>
              <TextInputV2
                keyName={'awsAccountId'}
                title="AWS account ID"
                type="text"
                placeHolder="AWS account ID"
                maxNumber={12}
                value={(values.awsAccountId || '') as string}
                isError={false}
                onChange={handleChange}
                isReadOnly={true}
                isRequired={false}
                errorText={''}
                showSpinner={false}
                onBlur={handleBlur}
              />
            </div>
          </Grid>
        </Grid>
      </div>
      <div>
        <Typography className={classes.subTitle}>Offer recipients</Typography>
        <OfferRecipientV2
          formik={
            formikProps as unknown as FormikProps<Record<string, unknown>>
          }
          smallSize={false}
        />
      </div>
      <div>
        <TextInputV2
          keyName={'emailCustomMessage'}
          title="Custom email message"
          type="text"
          placeHolder="Custom email message"
          value={(values.emailCustomMessage || '') as string}
          onChange={handleChange}
          isReadOnly={false}
          isRequired={false}
          showSpinner={false}
          onBlur={handleBlur}
          isError={!!(errors.emailCustomMessage && touched.emailCustomMessage)}
          errorText={
            (!!touched.emailCustomMessage && errors.emailCustomMessage) || ''
          }
        />
      </div>
      <div>
        <Typography className={classes.subTitle}>Offer details</Typography>
        <Grid container spacing={4}>
          <Grid size={6}>
            <div key={'offer-name'}>
              <TextInputV2
                keyName={'privateOfferName'}
                title="Offer name"
                type="text"
                placeHolder="Offer name"
                value={(values.privateOfferName || '') as string}
                onChange={handleChange}
                isReadOnly={false}
                isRequired={false}
                showSpinner={false}
                onBlur={handleBlur}
                isError={
                  !!(errors.privateOfferName && touched.privateOfferName)
                }
                errorText={
                  (!!touched.privateOfferName && errors.privateOfferName) || ''
                }
              />
            </div>
          </Grid>
          <Grid size={6}>
            <div key={'offer-expiration-date'}>
              <DatePickerV2
                format={labraUIDateFormat}
                views={['year', 'month', 'day']}
                field={offerExpiryDateField}
                fieldId={'offerExpirationDate'}
                showErrorHelper={
                  !!touched.offerExpirationDate &&
                  !isEmpty(errors.offerExpirationDate)
                }
                formik={
                  formikProps as unknown as FormikProps<Record<string, unknown>>
                }
                errorHelperText={
                  (!!touched.offerExpirationDate &&
                    errors.offerExpirationDate) ||
                  ''
                }
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
